<template>
  <v-card>
    <v-card-title>
      <h5>{{ title }}</h5>
    </v-card-title>
    <form v-if="ready === true" @submit.prevent="submit" @reset="initialize">
      <v-container fluid>
        <v-row>
          <v-col cols="6">
            <v-text-field
              class="validate"
              prepend-icon="dialpad"
              v-model="code"
              label="Code"
              required
              disabled
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              class="validate"
              prepend-icon="house"
              v-model="nom"
              label="Nom"
              required
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-select
              class="validate"
              prepend-icon="room"
              v-model="section.id"
              label="Section"
              :items="allSections"
            />
          </v-col>
          <!--<v-col cols="2">
            <v-select
              class="validate"
              prepend-icon="map"
              v-model="region.id"
              label="Région"
              :items="allRegions"
              disabled
            />
          </v-col>
          <v-col cols="2">
            <v-select
              class="validate"
              prepend-icon="work"
              v-model="societe.id"
              label="Société"
              :items="allSocietes"
              disabled
            />
          </v-col>-->
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-select
              class="validate"
              prepend-icon="assignment"
              v-model="typeId"
              label="Type"
              :items="allTypes"
            />
          </v-col>
          <v-col cols="8">
            <v-text-field
              class="validate"
              prepend-icon="person"
              v-model="referent"
              label="Référent"
              required
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-text-field
              class="validate"
              prepend-icon="language"
              v-model.number="latitude"
              label="Latitude"
              required
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              class="validate"
              prepend-icon="language"
              v-model.number="longitude"
              label="Longitude"
              required
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-switch
              prepend-icon="directions_boat"
              label="Accès péniche"
              v-model="peniche"
              disabled
            />
          </v-col>
          <v-col cols="2">
            <v-switch
              prepend-icon="train"
              label="Accès train"
              v-model="train"
              disabled
            />
          </v-col>
          <v-col cols="2">
            <v-switch
              prepend-icon="adjust"
              label="Calibreur"
              v-model="calibreur"
              disabled
            />
          </v-col>
          <v-col cols="2">
            <v-switch
              prepend-icon="blur_on"
              label="Nettoyeur"
              v-model="nettoyeur"
              disabled
            />
          </v-col>
          <v-col cols="2">
            <v-switch
              prepend-icon="toys"
              label="Séchoir"
              v-model="sechoir"
              disabled
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <template v-if="site">
              <v-btn class="scdf-yellow mr-2" type="submit">
                <v-icon>edit</v-icon>
                Valider
              </v-btn>
              <v-btn class="scdf-red" @click="close" type="reset">
                <v-icon>clear</v-icon>
                Annuler
              </v-btn>
            </template>
            <template v-else>
              <v-btn class="scdf-yellow mr-2" type="submit">
                <v-icon>add</v-icon>
                Ajouter
              </v-btn>
              <v-btn class="scdf-red" type="reset">
                <v-icon>clear</v-icon>
                Effacer
              </v-btn>
            </template>
          </v-col>
        </v-row>
      </v-container>
    </form>
    <v-skeleton-loader v-else type="table-thead" />
  </v-card>
</template>

<script>
import axios from 'axios';

export default {
  name: 'site-form',
  components: {
    // Boolean
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    site: {
      type: Object,
      default: null,
    },
  },
  data() {
    /*
      writable
        - nom_site
        - latitude
        - longitude
        - nom_referent
        - type de site
        - section

      read-only
        - flag_camion
        - flag_train
        - flag_peniche
        - flag_calibreur
        - flag_nettoyeur
        - flag_sechoir
        - region
        - societe
    */
    return {
      id: null,
      code: null,
      nom: null,
      region: {},
      section: null,
      societe: {},
      latitude: null,
      longitude: null,
      referent: null,
      typeId: null,
      typeName: null,
      peniche: false,
      train: false,
      calibreur: false,
      nettoyeur: false,
      sechoir: false,
      allSections: [],
      allSocietes: [],
      allRegions: [],
      allTypes: [],
      ready: false,
    };
  },
  methods: {
    initialize() {
      this.ready = false;
      if (this.site) {
        const allSectionsPromise = this.getAllSections();
        const allTypesPromise = this.getAllTypes();
        Promise.all([allSectionsPromise, allTypesPromise]).then(() => {
          this.ready = true;
        });
        this.id = this.site.refSite.id;
        this.code = this.site.refSite[process.env.VUE_APP_SITE_CODE];
        this.nom = this.site.refSite[process.env.VUE_APP_SITE_NOM];
        this.region = {
          id: this.site.regionId,
          name: this.site.regionName,
        };
        this.societe = {
          id: this.site.societeId,
          name: this.site.societeName,
        };
        this.section = {
          id: this.site.sectionId,
          name: this.site.sectionName,
        };
        this.allSocietes.push({
          value: this.site.societeId,
          text: this.site.societeName,
        });
        this.allRegions.push({
          value: this.site.regionId,
          text: this.site.regionName,
        });
        this.latitude = this.site.refSite[process.env.VUE_APP_SITE_LATITUDE];
        this.longitude = this.site.refSite[process.env.VUE_APP_SITE_LONGITUDE];
        this.referent = this.site.refSite[process.env.VUE_APP_SITE_REFERENT];
        this.typeId = this.site.typeId;
        this.typeName = this.site.typeNom;
        this.peniche = this.site.refSite.peniche;
        this.train = this.site.refSite.train;
        this.calibreur = this.site.refSite.calibreur;
        this.nettoyeur = this.site.refSite.nettoyeur;
        this.sechoir = this.site.refSite.sechoir;
      }
    },
    getAllSections() {
      const url =
        process.env.VUE_APP_BASE_URL +
        'api/refCooperativeHasRefSections/search/findByRefCooperativeIdEquals?refCooperativeId=' +
        this.$store.state.userCoopId +
        '&projection=section';
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: url,
          headers: {
            user: this.$store.state.userInfos.email,
          },
        })
          .then(res => {
            this.allSections = res.data._embedded.datas.map(e => ({
              text: `${e.sectionNom} / ${e.regionNom} / ${e.societeNom}`,
              value: e.sectionId,
            }));
            resolve(true);
          })
          .catch(() => {
            reject(false);
          });
      });
    },
    getAllTypes() {
      const url = process.env.VUE_APP_BASE_URL + process.env.VUE_APP_SITE_TYPES;
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: url,
          headers: {
            user: this.$store.state.userInfos.email,
          },
        })
          .then(res => {
            this.allTypes = res.data._embedded.datas.map(e => ({
              text: e.nom,
              value: e.id,
            }));
            resolve(true);
          })
          .catch(() => {
            reject(false);
          });
      });
    },
    submit() {
      const argSite = {
        idSite: this.id,
        nom: this.nom,
        refSection: 'refSections/' + this.section.id,
        latitude: this.latitude,
        longitude: this.longitude,
        referent: this.referent,
        type: 'siteTypes/' + this.typeId,
      };
      this.$emit(this.site ? 'edit-site' : 'submit-site', argSite);
      this.code = null;
      this.nom = null;
      this.region = null;
      this.section = null;
      this.societe = null;
      this.latitude = null;
      this.longitude = null;
      this.referent = null;
      this.typeId = null;
      this.typeNom = null;
      this.peniche = false;
      this.train = false;
      this.calibreur = false;
      this.nettoyeur = false;
      this.sechoir = false;
      this.close();
    },
    close() {
      this.$emit('close-expansion');
    },
  },

  created() {
    this.initialize();
  },
};
</script>

<style lang="scss" scoped>
.checkbox-field {
  display: flex;
  height: 100%;
  overflow: visible;
  flex-direction: column;
  justify-content: center;

  ::v-deep .v-input__slot {
    margin: 24px;
  }
}
</style>
